import React, { Component, createRef } from 'react';
import {
    Input, Button, Icon, Popover, Select, Radio, Modal, Spin, Checkbox,
} from 'antd';
import { connect } from 'react-redux';
import { debounce } from '../../../../shared/helpers';

const { Option } = Select;

const hintContent = {
    vrm: 'In the text box, please enter the registration of motorbike',
    brand: 'From the list, please select the make of bike',
    model: 'From the list, please select the model of bike',
    variant: 'In the text box, please enter the variant of motorbike',
    bike_cc: 'In the text box, please enter the size of motorbike engine in cc (e.g 125, 650 etc)',
    year: 'From the list, please select the year bike was manufactured',
    colour: 'In the text box below, please tell us what colour bike is',
    mot: 'Using the options, please let us know how long customer have left on current MOT for the vehicle',
};

const formFieldStyle = {
    mainContainer: { marginTop: 5 },
    fieldStyle: { width: 428 },
    container: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' },
    wrapper: { width: '100%' },
    hintContainer: { display: 'flex', alignItems: 'center', marginTop: 7 },
    hintIconStyle: { marginLeft: 10, fontSize: 18 },
    errorIconStyle: { margin: '0 5px' },
};


class BikeInfo extends Component {
    state = {
        searched_model: false,
        model_manually: false,
    };

    formRef = createRef();

    componentDidMount() {
        this.formRef.current.on('keyup', '[db_key]', (event) => {
            const db_key = event.target.getAttribute('db_key');
            const { value } = event.target;

            // this.props.Lead_create_data.ref_bike_lead.set({[db_key]: value});
            this.props.Lead_create_data.set(`ref_bike_lead.${db_key}`, value);
            this.forceUpdate();
        });
    }

    handleChange = (value, path) => {
        this.props.Lead_create_data.set({ [path]: value });
        this.forceUpdate();
    };

    modelManually = (e) => this.setState({ model_manually: e.target.checked });

    modelSearch = (searchText) => {
        this.setState({ searched_model: true });
        this.runFetch({
            searchText,
            brandId: this.props.Lead_create_data.ref_bike_lead.ref_bike_brand && this.props.Lead_create_data.ref_bike_lead.ref_bike_brand.toJSON(),
        }, this.getBikeModelsRequest);
    };


    findBike = (vrm) => {
        this.props.dispatch({ type: 'FIND_BIKE_REQUEST', vrm });
    };

    getBikeBrandsRequest = (params) => {
        this.props.dispatch({ type: 'GET_BIKE_BRANDS_REQUEST', params });
    }

    getBikeModelsRequest = (params) => {
        this.props.dispatch({ type: 'GET_BIKE_MODELS_LEAD_CREATE_REQUEST', params });
    }

    buildVrmLookupModal() {
        if (!this.props.bike_info_by_vrm.showModal) {
            return true;
        }

        if (this.props.bike_info_by_vrm.data.experian === null || this.props.bike_info_by_vrm.data.experian === undefined) {
            Modal.error({
                title: 'Error',
                content: (<p>Experian couldn't find a valid bike</p>),
                onOk: () => {
                    this.props.dispatch({
                        type: 'SET_LEAD_CREATE_DATA',
                        payload: {
                            'bike_info_by_vrm.showModal': false,
                        },
                    });
                },
            });
        } else if (!this.props.bike_info_by_vrm.data.matchType === 'None') {
            Modal.info({
                title: 'Not found',
                content: 'Bike with provided VRM was not found',
                onOk: () => {
                    this.props.dispatch({
                        type: 'SET_LEAD_CREATE_DATA',
                        payload: {
                            'bike_info_by_vrm.showModal': false,
                        },
                    });
                },
            });
        } else {
            const { bike_info_by_vrm } = this.props;
            const variantId = bike_info_by_vrm.data.variant_id && bike_info_by_vrm.data.variant_id !== '' && bike_info_by_vrm.data.variant_id;

            Modal.confirm({
                title: 'Is this the customers motorbike?',
                width: 650,
                content: (
                    <div>
                        <div>
                            <strong>VRM: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.vrm}</span>
                        </div>
                        <div>
                            <strong>Experian Bike Name: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.makeModel}</span>
                        </div>
                        <div>
                            <strong>Make: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.make}</span>
                        </div>
                        <div>
                            <strong>Model: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.model}</span>
                        </div>
                        {(this.props.bike_info_by_vrm.data.model_variant || this.props.bike_info_by_vrm.model_variant)
                        && (
                            <div>
                                <strong>Variant: </strong>
                                <span>{this.props.bike_info_by_vrm.data.model_variant || this.props.bike_info_by_vrm.data.model_variant}</span>
                            </div>
                        )}
                        <div>
                            <strong>Year manufactured: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.yearOfManufacture}</span>
                        </div>
                        <div>
                            <strong>Colour: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.colour}</span>
                        </div>
                        <div>
                            <strong>Engine capacity: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.engineCapacity}</span>
                        </div>
                        <div>
                            <strong>Has ABS: </strong>
                            <span>
                                {this.props.bike_info_by_vrm.data.experian.model.toLowerCase().includes('abs') ? 'YES' : 'NO'}
                                {' '}
                                (According to the Experian name)
                            </span>
                        </div>
                    </div>
                ),
                okText: 'Continue',
                cancelText: 'Not customer bike?',
                onOk: () => {
                    if (this.props.bike_info_by_vrm.data.model === '') {
                        this.props.Lead_create_data.set({
                            'ref_bike_lead.vrm': this.props.bike_info_by_vrm.data.experian.vrm,
                            'ref_bike_lead.ref_bike_brand_name': this.props.bike_info_by_vrm.data.brand,
                            'ref_bike_lead.ref_bike_brand': this.props.bike_info_by_vrm.data.brand_id, // (this.props.brands.data && this.props.brands.data[0] && this.props.brands.data[0]._id) && this.props.brands.data[0]._id,
                            'ref_bike_lead.unmaped_data.bike_model': this.props.bike_info_by_vrm.data.experian.model,
                            'ref_bike_lead.unmaped_data.bike_model_variant': this.props.bike_info_by_vrm.data.model_variant || this.props.bike_info_by_vrm.model_variant || '',
                            'ref_bike_lead.unmaped_data.bike_cc': this.props.bike_info_by_vrm.data.experian.engineCapacity,
                            'ref_bike_lead.unmaped_data.bike_year': this.props.bike_info_by_vrm.data.experian.yearOfManufacture,
                            'ref_bike_lead.bike_year': this.props.bike_info_by_vrm.data.experian.yearOfManufacture,
                            'ref_bike_lead.colour': this.props.bike_info_by_vrm.data.experian.color,
                            min_age: this.props.bike_info_by_vrm.data.minAge,
                            maximum_mileage: this.props.bike_info_by_vrm.data.mileageLimit,
                            is_bike_we_want: this.props.bike_info_by_vrm.data.isBikeWeWant,
                            match_type: this.props.bike_info_by_vrm.data.matchType,
                        });
                        this.setState({ searched_model: true, model_manually: true });
                    } else {
                        this.props.Lead_create_data.set({
                            'ref_bike_lead.vrm': this.props.bike_info_by_vrm.data.experian.vrm,
                            'ref_bike_lead.ref_bike_brand_name': this.props.bike_info_by_vrm.data.brand,
                            'ref_bike_lead.ref_bike_brand': this.props.bike_info_by_vrm.data.brand_id, // (this.props.brands.data && this.props.brands.data[0] && this.props.brands.data[0]._id) && this.props.brands.data[0]._id,
                            'ref_bike_lead.ref_bike_variant': variantId || undefined,
                            'ref_bike_lead.ref_bike_model_name': this.props.bike_info_by_vrm.data.model,
                            'ref_bike_lead.ref_bike_model': this.props.bike_info_by_vrm.data.model_id,
                            'ref_bike_lead.temporary.bike_cc': this.props.bike_info_by_vrm.data.experian.engineCapacity,
                            'ref_bike_lead.unmaped_data.bike_cc': this.props.bike_info_by_vrm.data.experian.engineCapacity,
                            'ref_bike_lead.temporary.bike_model_variant': this.props.bike_info_by_vrm.data.model_variant,
                            // "ref_bike_lead.unmaped_data.bike_model_variant": this.props.bike_info_by_vrm.data.model_variant,
                            'ref_bike_lead.temporary.bike_year': this.props.bike_info_by_vrm.data.experian.yearOfManufacture,
                            'ref_bike_lead.unmaped_data.bike_year': this.props.bike_info_by_vrm.data.experian.yearOfManufacture,
                            'ref_bike_lead.bike_year': this.props.bike_info_by_vrm.data.experian.yearOfManufacture,
                            'ref_bike_lead.colour': this.props.bike_info_by_vrm.data.experian.colour,
                            min_age: this.props.bike_info_by_vrm.data.minAge,
                            maximum_mileage: this.props.bike_info_by_vrm.data.mileageLimit,
                            is_bike_we_want: this.props.bike_info_by_vrm.data.isBikeWeWant,
                            match_type: this.props.bike_info_by_vrm.data.matchType,
                        });
                        this.setState({ searched_model: true });
                    }

                    if (this.props.bike_info_by_vrm.data.brand_id) {
                        this.getBikeBrandsRequest({ _id: this.props.bike_info_by_vrm.data.brand_id });
                    }

                    if (this.props.bike_info_by_vrm.data.model_id) {
                        this.getBikeModelsRequest({ _id: this.props.bike_info_by_vrm.data.model_id });
                    }

                    this.props.dispatch({
                        type: 'GET_LEAD_CREATE_BIKE_EXPERIAN_CATALOG',
                        params: {
                            brand_id: this.props.bike_info_by_vrm.data.brand_id,
                            model_id: this.props.bike_info_by_vrm.data.model_id,
                        },
                    });

                    this.props.dispatch({
                        type: 'SET_LEAD_CREATE_DATA',
                        payload: {
                            'bike_info_by_vrm.showModal': false,
                        },
                    });
                },
                onCancel: () => {
                    this.props.dispatch({
                        type: 'SET_LEAD_CREATE_DATA',
                        payload: {
                            'bike_info_by_vrm.showModal': false,
                        },
                    });
                },
            });
        }

        return true;
    }

    requestData = (params, callback) => callback(params);

    runFetch = debounce(this.requestData, 500);

    render() {
        const { brands, models, bike_info_by_vrm } = this.props;
        const data = this.props.Lead_create_data;
        data.errors = {};
        data.validateSync();

        return this.props.bikeInfoIsLoading
            ? (
                <div style={{ width: 470, position: 'relative' }}>
                    <Spin
                        tip="Loading..."
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%)',
                        }}
                    />
                </div>
            )
            : this.buildVrmLookupModal() && (
                <div style={{ maxWidth: 470, marginBottom: 20 }} ref={this.formRef}>
                    <div style={formFieldStyle.mainContainer}>
                        <h5>VRM</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Input
                                    maxLength={10}
                                    placeholder="Enter bike vrm"
                                    db_key="vrm"
                                    style={{ maxWidth: 325 }}
                                    defaultValue={data.ref_bike_lead.vrm}
                                />
                                <span
                                    style={{
                                        display: 'block',
                                        color: 'red',
                                        visibility: data.errors['ref_bike_lead.vrm']
                                            ? 'visible'
                                            : 'hidden',
                                    }}
                                >
                                    <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                    {data.errors['ref_bike_lead.vrm'] && data.errors['ref_bike_lead.vrm'].message}
                                </span>
                            </div>


                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    type="primary"
                                    icon="search"
                                    loading={bike_info_by_vrm.loading}
                                    onClick={() => this.findBike(data.ref_bike_lead.vrm)}
                                >
                                    Lookup
                                </Button>
                                <Popover content={hintContent.vrm} trigger="click">
                                    <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                                </Popover>
                            </div>
                        </div>
                    </div>

                    <div style={formFieldStyle.mainContainer}>
                        <h5>Bike make</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Select
                                    db_key_select="ref_bike_brand"
                                    defaultValue={data.ref_bike_lead.ref_bike_brand && data.ref_bike_lead.ref_bike_brand.toJSON()}
                                    showSearch
                                    allowClear
                                    style={formFieldStyle.fieldStyle}
                                    placeholder="Select Make"
                                    optionFilterProp="children"
                                    onSearch={(searchText) => this.runFetch({ searchText }, this.getBikeBrandsRequest)}
                                    onChange={(value) => this.handleChange(value, 'ref_bike_lead.ref_bike_brand')}
                                    filterOption={() => true}
                                >
                                    {
                                        brands.data.map((brand) => <Option key={brand._id} value={brand._id}>{brand.name}</Option>)
                                    }
                                </Select>

                                <span
                                    style={{
                                        display: 'block',
                                        color: 'red',
                                        visibility: data.errors['ref_bike_lead.ref_bike_brand']
                                            ? 'visible'
                                            : 'hidden',
                                    }}
                                >
                                    <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                    {data.errors['ref_bike_lead.ref_bike_brand'] && data.errors['ref_bike_lead.ref_bike_brand'].message}
                                </span>
                            </div>


                            <div style={formFieldStyle.hintContainer}>
                                <Popover content={hintContent.brand} trigger="click">
                                    <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                                </Popover>
                            </div>
                        </div>
                    </div>


                    <div style={formFieldStyle.mainContainer}>
                        <h5>
                            Bike model
                            <span style={{ marginLeft: 10, fontWeight: 400, fontSize: 8 }}>
                                <Checkbox
                                    disabled={!(this.state.searched_model && models.data.length === 0)}
                                    onChange={this.modelManually}
                                    checked={this.state.model_manually}
                                >
                                    Enter model manually (if not found in model list)
                                </Checkbox>
                            </span>
                        </h5>

                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                {
                                    !this.state.model_manually
                                        ? (
                                            <>
                                                <Select
                                                    disabled={!(data.ref_bike_lead.ref_bike_brand && data.ref_bike_lead.ref_bike_brand.toJSON())}
                                                    db_key_select="ref_bike_model"
                                                    defaultValue={
                                                        (data.ref_bike_lead.ref_bike_model && data.ref_bike_lead.ref_bike_model.toJSON())
                                            || (data.ref_bike_lead.unmaped_data && data.ref_bike_lead.unmaped_data.bike_model)
                                                    }
                                                    showSearch
                                                    allowClear
                                                    style={formFieldStyle.fieldStyle}
                                                    placeholder="Select model"
                                                    optionFilterProp="children"
                                                    onSearch={this.modelSearch}
                                                    onChange={(value, el) => {
                                                        if (!el) {
                                                            this.handleChange('', 'ref_bike_lead.ref_bike_model');
                                                        } else if (el.props) {
                                                            this.handleChange(el.props.db_data, 'ref_bike_lead.ref_bike_model');
                                                        } else {
                                                            this.handleChange(value, 'ref_bike_lead.ref_bike_model');
                                                        }
                                                    }}
                                                    filterOption={() => true}
                                                >
                                                    {
                                                        models.data.map((model) => (
                                                            <Option
                                                                key={model._id}
                                                                value={model._id}
                                                                db_data={model}
                                                            >
                                                                {`${model.name} ${model.model_variation} - ${model.cc} cc`}
                                                            </Option>
                                                        ))
                                                    }
                                                </Select>
                                            </>
                                        )
                                        : (
                                            <Input
                                                style={formFieldStyle.fieldStyle}
                                                db_key="unmaped_data.bike_model"
                                                placeholder="Enter model please"
                                                defaultValue={data.ref_bike_lead.unmaped_data.bike_model}
                                            />
                                        )
                                }

                                <span
                                    style={{
                                        display: 'block',
                                        color: 'red',
                                        visibility: data.errors['ref_bike_lead.ref_bike_model']
                                            ? 'visible'
                                            : 'hidden',
                                    }}
                                >
                                    <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                    {data.errors['ref_bike_lead.ref_bike_model'] && data.errors['ref_bike_lead.ref_bike_model'].message}
                                </span>
                            </div>


                            <div style={formFieldStyle.hintContainer}>
                                <Popover content={hintContent.model} trigger="click">
                                    <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                                </Popover>
                            </div>
                        </div>
                    </div>

                    <div style={formFieldStyle.mainContainer}>
                        <h5>Engine size</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Input
                                    type="number"
                                    maxLength="10"
                                    placeholder="Enter engine size"
                                    db_key="unmaped_data.bike_cc"
                                    style={formFieldStyle.fieldStyle}
                                    defaultValue={
                                        (data.ref_bike_lead.temporary && data.ref_bike_lead.temporary.bike_cc)
                                    || data.ref_bike_lead.unmaped_data.bike_cc
                                    || ''
                                    }
                                />
                                <span
                                    style={{
                                        color: 'red',
                                        visibility: data.errors['ref_bike_lead.unmaped_data.bike_cc']
                                            ? 'visible'
                                            : 'hidden',
                                    }}
                                >
                                    <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                    {data.errors['ref_bike_lead.unmaped_data.bike_cc'] && data.errors['ref_bike_lead.unmaped_data.bike_cc'].message}
                                </span>
                            </div>


                            <div style={formFieldStyle.hintContainer}>
                                <Popover content={hintContent.bike_cc} trigger="click">
                                    <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                                </Popover>
                            </div>
                        </div>
                    </div>

                    <div style={formFieldStyle.mainContainer}>
                        <h5>Model variant (e.g. Bandit)</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Input
                                    maxLength="255"
                                    placeholder="Enter variant"
                                    db_key="unmaped_data.bike_model_variant"
                                    style={formFieldStyle.fieldStyle}
                                    defaultValue={
                                        (data.ref_bike_lead.temporary && data.ref_bike_lead.temporary.bike_model_variant)
                                    || data.ref_bike_lead.unmaped_data.bike_model_variant
                                    || ''
                                    }
                                />
                                <span
                                    style={{
                                        display: 'block',
                                        color: 'red',
                                        visibility: data.errors['ref_bike_lead.ref_bike_variant']
                                            ? 'visible'
                                            : 'hidden',
                                    }}
                                >
                                    <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                    {data.errors['ref_bike_lead.ref_bike_variant'] && data.errors['ref_bike_lead.ref_bike_variant'].message}
                                </span>
                            </div>


                            <div style={formFieldStyle.hintContainer}>
                                <Popover content={hintContent.variant} trigger="click">
                                    <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                                </Popover>
                            </div>
                        </div>
                    </div>


                    <div style={formFieldStyle.mainContainer}>
                        <h5>Year manufactured </h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Input
                                    maxLength="10"
                                    placeholder="Enter year"
                                    db_key="bike_year"
                                    style={formFieldStyle.fieldStyle}
                                    defaultValue={
                                        (data.ref_bike_lead && data.ref_bike_lead.bike_year)
                                    || data.ref_bike_lead.bike_year
                                    || ''
                                    }
                                />
                                <span
                                    style={{
                                        color: 'red',
                                        visibility: data.errors['ref_bike_lead.bike_year']
                                            ? 'visible'
                                            : 'hidden',
                                    }}
                                >
                                    <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                    {data.errors['ref_bike_lead.bike_year'] && data.errors['ref_bike_lead.bike_year'].message}
                                </span>
                            </div>


                            <div style={formFieldStyle.hintContainer}>
                                <Popover content={hintContent.year} trigger="click">
                                    <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                                </Popover>
                            </div>
                        </div>
                    </div>


                    <div style={formFieldStyle.mainContainer}>
                        <h5>Colour</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Input
                                    maxLength="20"
                                    placeholder="Enter bike colour"
                                    db_key="colour"
                                    style={formFieldStyle.fieldStyle}
                                    defaultValue={data.ref_bike_lead.colour}
                                />
                                <span
                                    style={{
                                        color: 'red',
                                        visibility: data.errors['ref_bike_lead.colour']
                                            ? 'visible'
                                            : 'hidden',
                                    }}
                                >
                                    <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                    {data.errors['ref_bike_lead.colour'] && data.errors['ref_bike_lead.colour'].message}
                                </span>
                            </div>


                            <div style={formFieldStyle.hintContainer}>
                                <Popover content={hintContent.colour} trigger="click">
                                    <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                                </Popover>
                            </div>
                        </div>
                    </div>
                    <div style={formFieldStyle.mainContainer}>
                        <h5>MOT(please select)</h5>
                        <div style={formFieldStyle.container}>
                            <div style={formFieldStyle.wrapper}>
                                <Radio.Group
                                    defaultValue={data.ref_bike_lead.mot_history_customer}
                                    buttonStyle="solid"
                                    onChange={(e) => this.handleChange(e.target.value, 'ref_bike_lead.mot_history_customer')}
                                >
                                    <Radio.Button value="Over 1 month">Over 1 month</Radio.Button>
                                    <Radio.Button value="Under 1 month">Under 1 month</Radio.Button>
                                    <Radio.Button value="Not required">Not required</Radio.Button>
                                    <Radio.Button value="Expired">Expired</Radio.Button>
                                </Radio.Group>
                                <span
                                    style={{
                                        display: 'block',
                                        color: 'red',
                                        visibility: data.errors['ref_bike_lead.mot_history_customer']
                                            ? 'visible'
                                            : 'hidden',
                                    }}
                                >
                                    <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                    {data.errors['ref_bike_lead.mot_history_customer'] && data.errors['ref_bike_lead.mot_history_customer'].message}
                                </span>
                            </div>


                            <div style={formFieldStyle.hintContainer}>
                                <Popover content={hintContent.mot} trigger="click">
                                    <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                                </Popover>
                            </div>
                        </div>
                    </div>
                </div>
            );
    }
}

const mapStateToProps = (state) => {
    const {
        brands, models, variants, bike_info_by_vrm, bikeInfoIsLoading,
    } = state.Leads.Lead_create;
    return {
        brands, models, variants, bike_info_by_vrm, bikeInfoIsLoading,
    };
};

export default connect(mapStateToProps)(BikeInfo);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/components/BikeInfo.js